/* (c) Copyright Frontify Ltd., all rights reserved. */

import { createFondueIcon } from '../createFondueIcon';

/**
 * @component @name ArrowTopLeft
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij48cGF0aCBmaWxsPSJjdXJyZW50Q29sb3IiIGQ9Ik0xNS43OCA1LjUzYS43NS43NSAwIDExMCAxLjVIOC4wOWw5Ljk4OSA5Ljk4OGEuNzUuNzUgMCAwMS0xLjA2IDEuMDZMNy4wMyA4LjA5MXY3LjY5YS43NS43NSAwIDAxLTEuNSAwVjUuNTN6Ii8+PC9zdmc+) - https://fondue-components.frontify.com/?path=/story/icons_icons--default&args=iconName:arrow-top-left
 * @see https://fondue-components.frontify.com/?path=/story/icons_icons--default - Documentation
 */
export const IconArrowTopLeft = createFondueIcon('ArrowTopLeft', [["path",{"fill":"currentColor","d":"M15.78 5.53a.75.75 0 110 1.5H8.09l9.989 9.988a.75.75 0 01-1.06 1.06L7.03 8.091v7.69a.75.75 0 01-1.5 0V5.53z"}]]);
